import { createSlice } from '@reduxjs/toolkit';
import { addContact, getContacts, deleteContact } from './contactThunks';

const contactSlice = createSlice({
    name: 'contacts',
    initialState: {
        addContactLodading: null,
        addContactError: null,
        addContactFullfill: null,

        getContactsLoading: null,
        getContactsError: null,
        getContactsFullfill: null,

        deleteContactLoading: null,
        deleteContactError: null,
        deleteContactFullfill: null
    },
    reducers: {
        resetContactAuth: (state) => {
            state.addContactLodading = null;
            state.addContactError = null;
            state.addContactFullfill = null;
        },
    },
    extraReducers: (builder) => {
        // Handle addContact actions
        builder

            .addCase(addContact.pending, (state) => {
                state.addContactLodading = true;
            })
            .addCase(addContact.fulfilled, (state, action) => {
                state.addContactLodading = false;
                state.addContactFullfill = action.payload
            })
            .addCase(addContact.rejected, (state, action) => {
                state.addContactLodading = true;
                state.addContactError = action.payload;
            });

        // Handle getContacts actions
        builder
            .addCase(getContacts.pending, (state) => {
                state.getContactsLoading = true;
            })

            .addCase(getContacts.fulfilled, (state, action) => {
                state.getContactsLoading = false;
                state.getContactsFullfill = action.payload;
            })

            .addCase(getContacts.rejected, (state, action) => {
                state.getContactsLoading = true;
                state.getContactsError = action.payload;
            });

        // Handle deleteContact actions
        builder
            .addCase(deleteContact.pending, (state) => {
                state.deleteContactLoading = true;
            })
            .addCase(deleteContact.fulfilled, (state, action) => {
                state.deleteContactLoading = false;
                state.deleteContactFullfill = action.payload;
            })
            .addCase(deleteContact.rejected, (state, action) => {
                state.deleteContactLoading = true;
                state.deleteContactError = action.payload;
            });
    },
});
export const { resetContactAuth } = contactSlice.actions;
// Export the reducer
export default contactSlice.reducer;
